module.exports = __webpack_public_path__ + "img/contact.b39b605a.svg";